import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@services/api.service';
import { environment } from '@env/environment';
import { BetaFeatureModel, PaginatedResultModel, PaginatorModel } from '@data-layer/models/common';
import { UserBetaFlagModel } from '@data-layer/models/user';
import { BetaFeatureSearchModel } from '../models/common/beat-feature-search-model';

@Injectable({
  providedIn: 'root',
})
export class BetaFlagsRepository {
  constructor(private apiService: ApiService) {}

  public getAppBetaFeatures(params?: BetaFeatureSearchModel, isShowLoader: boolean = false): Observable<UserBetaFlagModel[]> {
    let paramsObject = params;
    if (!!params) {
      //Ensures no null fields are sent with this object
      paramsObject = Object.keys(params)
        .filter((key) => params[key] !== null)
        .reduce((obj, key) => {
          obj[key] = params[key];
          return obj;
        }, {});
    }

    return this.apiService.get(`${environment.url.prefixCustoms}v2/beta-features`, { params: paramsObject }, { isShowLoader });
  }

  public getUserBetaFeaturesManagement(userId: string): Observable<PaginatedResultModel<UserBetaFlagModel>> {
    return this.apiService.get<PaginatedResultModel<UserBetaFlagModel>>(
      `${environment.url.prefixCustoms}v2/users-management/${userId}/beta-features`,
    );
  }

  public getBetaFeaturesManagement(params?: PaginatorModel): Observable<PaginatedResultModel<BetaFeatureModel>> {
    return this.apiService.get<PaginatedResultModel<BetaFeatureModel>>(`${environment.url.betaFeaturesManagement}`, {
      params,
    });
  }

  public createBetaFeatureManagement(betaFeatures: BetaFeatureModel): Observable<BetaFeatureModel> {
    return this.apiService.post<BetaFeatureModel>(`${environment.url.betaFeaturesManagement}`, betaFeatures);
  }

  public updateBetaFeatureManagement(betaFeature: BetaFeatureModel): Observable<BetaFeatureModel> {
    return this.apiService.put<BetaFeatureModel>(`${environment.url.betaFeaturesManagement}${betaFeature.id}`, betaFeature);
  }

  public deleteBetaFeatureManagement(id: number): Observable<BetaFeatureModel> {
    return this.apiService.delete<BetaFeatureModel>(`${environment.url.betaFeaturesManagement}${id}`);
  }
}
